import React, {
  FC, useCallback, useRef, useState,
} from 'react';
import { ICalendarUrl, setClass } from '@utils';
import { isMobile } from 'react-device-detect';
import { Input } from '../input';
import { Lock } from '../svgs';
import { Popover } from '../Popover';
import { CalendarColorSelect } from '../calendarColorSelect/CalendarColorSelect';
import { IColor } from '../../utils/types/colors';
import '../../styles/components/calendarTitle.scss';

interface CalendarTitleProps {
  calendar: ICalendarUrl;
  colors?: IColor[];
  changing?: boolean;
  onChange?: (calendar: ICalendarUrl) => void;
  onChangeClick?: (id: number) => void;
  getColor: (name: string) => IColor;
  error: boolean;
  setErr?: (value: boolean) => void;
}

export const CalendarTitle: FC<CalendarTitleProps> = ({
  calendar, changing, colors, error, onChange, getColor,
  onChangeClick, setErr,
}) => {
  const ref = useRef<HTMLDivElement>();

  const onChangeLock = useCallback(() => {
    onChange({ ...calendar, calendarType: calendar.calendarType === 'WORK' ? 'PERSONAL' : 'WORK' });
  }, [calendar]);

  const onChangeColor = useCallback((calendarColor: string) => {
    onChange({ ...calendar, calendarColor: getColor(calendarColor).colorName });
  }, [calendar]);

  const [openColorSelect, setOpenColorSelect] = useState(false);
  const onOpenColorSelect = () => changing && setOpenColorSelect((prev) => !prev);
  const onEditClick = useCallback(() => onChangeClick(calendar.id), [calendar]);
  const onChangeTitle = useCallback((title: string) => {
    onChange({ ...calendar, title });
    error && setErr(false);
  }, [calendar, error]);

  return (
    <div className={setClass('title-part', isMobile && 'mobile')}>
      <div className="circle-title-part">
        <div
          ref={ref}
          className="circle"
          style={{ backgroundColor: getColor(calendar?.calendarColor)?.hexCode }}
          onClick={onOpenColorSelect}
        />
        <Popover
          ref={ref}
          open={openColorSelect}
          onClose={onOpenColorSelect}
        >
          <CalendarColorSelect
            colors={colors}
            selectedColor={calendar.calendarColor}
            onChangeColor={onChangeColor}
          />
        </Popover>
        {changing
          ? (
            <Input
              variant="underlined"
              value={calendar.title}
              placeholder="Название каледаря"
              onChange={onChangeTitle}
              error={error}
            />
          )
          : (
            <>
              <p className="title">{calendar.title}</p>
              {calendar.calendarType !== 'WORK' && <Lock />}
            </>
          )}
      </div>
      {
        changing
          ? (
            <Lock
              tooltip
              open={calendar.calendarType === 'WORK'}
              onClick={onChangeLock}
            />
          )
          : (
            <p
              onClick={onEditClick}
              className="change-label"
            >
              Изменить
            </p>
          )
      }
    </div>
  );
};
